import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { Splide } from '@splidejs/react-splide';
import classNames from 'classnames';
import { forwardRef } from 'react';
import DCarouselSlide from './components/DCarouselSlide';
function DCarousel(_a, ref) {
    var { children, className, style, options, dataAttributes } = _a, props = __rest(_a, ["children", "className", "style", "options", "dataAttributes"]);
    return (_jsx(Splide, Object.assign({ className: classNames('d-carousel', className), style: style, ref: ref, options: Object.assign(Object.assign({}, options), { classes: {
                // Arrows
                arrows: 'splide__arrows d-carousel-arrows',
                arrow: 'splide__arrow d-carousel-arrow',
                prev: 'splide__arrow--prev d-carousel-arrow-prev',
                next: 'splide__arrow--next d-carousel-arrow-next',
                // Paginator
                pagination: 'splide__pagination d-carousel-pagination',
                page: 'splide__pagination__page d-carousel-pagination-page',
            } }) }, dataAttributes, props, { children: children })));
}
const ForwardedDCarousel = forwardRef(DCarousel);
ForwardedDCarousel.displayName = 'DCarousel';
export default Object.assign(ForwardedDCarousel, {
    Slide: DCarouselSlide,
});
//# sourceMappingURL=DCarousel.js.map